import { Operation } from '@occc-app/offerHelpers/types';
import { isFieldWithPathDirty } from '@occc-app/offerHelpers/utils';
import { makeDeleteOperation } from '@occc-app/offerHelpers/operations/makeDeleteOperation';

import { getUpdateLimitOperation } from './get-update-limit-operation';
import { LimitsGroupFormValue, MakeLimitOperations } from './types';
import { getCreateLimitOperation } from './get-create-limit-operation';

export const makeLimitOperations: MakeLimitOperations = (
  offerId: string,
  values,
  limitScope,
  limitType,
  dirtyFields,
): Operation[] => {
  if (!isFieldWithPathDirty<LimitsGroupFormValue>(dirtyFields, `${limitType}.${limitScope}`)) {
    return [];
  }

  const configuration = values[limitScope];

  if (!configuration) {
    return [];
  }

  const operations: Operation[] = [];

  const createOperation = getCreateLimitOperation(offerId, values, limitScope, limitType);
  const isTimePeriodDirty = isFieldWithPathDirty<LimitsGroupFormValue>(
    dirtyFields,
    `${limitType}.${limitScope}.timePeriod`,
  );

  if (configuration.id && createOperation && !isTimePeriodDirty) {
    const updateOperation = getUpdateLimitOperation(
      configuration.id,
      configuration,
      limitScope,
      limitType,
    );

    if (updateOperation) {
      operations.push(updateOperation);
    }

    return operations;
  }

  if (configuration.id) {
    operations.push(makeDeleteOperation('limitDelete', configuration.id));
  }

  if (createOperation) {
    operations.push(createOperation);
  }

  return operations;
};
